//#region enums
export enum importTypes {
	EXCEL = "EXCEL",
	CSV = "CSV",
	XML = "XML",
	JSON = "JSON"
}
export enum sourceFileTypes {
	FOLDER = "FOLDER",
	API = "API",
	AZURE_CLOUD = "AZURE_CLOUD"
}

export enum apiAuthenticationTypes {
	NONE = "NONE",
	BEARER_TOKEN = "BEARER_TOKEN"
}

export enum fileSelectorTypes {
	ONE_FILE = "ONE_FILE",
	MULTIPLE_FILES = "MULTIPLE_FILES",
	NAME_CONTAINS = "NAME_CONTAINS",
	NAME_START = "NAME_START",
	ALL_FILES = "ALL_FILES"
}

export enum fileSortTypes {
	ASC_MODIFIED_DATE = "ASC_MODIFIED_DATE",
	DESC_MODIFIED_DATE = "DESC_MODIFIED_DATE",
	ASC_ALPHABETIC = "ASC_ALPHABETIC",
	DESC_ALPHABETIC = "DESC_ALPHABETIC"
}
//#endregion enums

export class tableImportMapping {
	constructor() {
		this.itemID = 0;
		this.descrizione = null;
		this.importType = null;
		this.tableName = null;
		this.schemaFile = null;
		this.realTime = false;
		this.azioniPreElaborazione = null;
		this.azioniPostElaborazione = null;
		//escludo la prop perchè quando uso questo oggetto non la devo considerare lato js perchè sarebbe una string encodata
		//this.importMapping= null;
		this.dataCreazione = null;
		this.dataModifica = null;
		this.truncateTable = false;

		this.isOnProgressImport = false;
		this.hasSchemaChanged = false;
	}
	itemID: number;
	descrizione: string;
	importType: importTypes;
	tableName: string;
	schemaFile: string;
	realTime: boolean;
	azioniPreElaborazione: string;
	azioniPostElaborazione: string;
	truncateTable: boolean;
	//escludo la prop perchè quando uso questo oggetto non la devo considerare lato js perchè sarebbe una string encodata
	//importMapping: iImportConfiguration;
	dataCreazione: string | null;
	dataModifica: string | null;

	isOnProgressImport: boolean | null;

	hasSchemaChanged: boolean;
}
// forse non si usa
export class tableImportMappingViewModel extends tableImportMapping {
	constructor() {
		super();
		this.importConfiguration = new importConfiguration<configurationBase>();
	}
	importConfiguration: iImportConfiguration;
}
export interface iImportConfiguration {
	configurazione: iConfiguration;
	columnsMapping: iMappingField[];
}
export class importConfiguration<T extends configurationBase>
	implements iImportConfiguration {
	constructor() {
		this.configurazione = new configurationBase() as T;
		this.columnsMapping = [];
	}
	configurazione: T;
	columnsMapping: iMappingField[];
}
//#region configuration
export interface iConfiguration {
	sourceFile: sourceFileTypes;
	pathCaricamento: string;
	pathImportati: string;
	pathErrori: string;
}

export class configurationBase implements iConfiguration {
	constructor() {
		this.sourceFile = null;
		this.pathCaricamento = null;
		this.pathImportati = null;
		this.pathErrori = null;
		this.apiAuthenticationTypes = null;
		this.apiUrl = null;
		this.apiUser = null;
		this.apiPassword = null;
		this.pathSourceImport = null;
		this.pollingTime = null;
		this.fileSelector = fileSelectorTypes.ONE_FILE;
		this.fileSort = fileSortTypes.DESC_MODIFIED_DATE;
		this.multiFile = false;
		this.deleteOriginalFileAfterDownload = false;
	}
	sourceFile: sourceFileTypes;
	pathSourceImport: string;
	pollingTime: number;
	pathCaricamento: string;
	fileSelector: fileSelectorTypes;
	fileSort: fileSortTypes;
	multiFile: boolean;
	deleteOriginalFileAfterDownload: boolean;
	pathImportati: string;
	pathErrori: string;
	apiAuthenticationTypes: sourceFileTypes;
	apiUrl: string;
	apiUser: string;
	apiPassword: string;
}

export class configurationXML extends configurationBase {
	constructor() {
		super();
		this.formatoDate = null;
		this.separatoreDecimale = null;
	}
	formatoDate: string;
	separatoreDecimale: string;
}
export class configurationCSV extends configurationBase {
	constructor() {
		super();
		this.intestazioniSuPrimaRiga = true;
		this.separatore = ';';
		this.quote = '"';
		this.primaRigaDati = 1;
		this.formatoDate = null;
		this.separatoreDecimale = null;
	}
	intestazioniSuPrimaRiga: boolean;
	separatore: string;
	quote: string;
	primaRigaDati: number;
	formatoDate: string;
	separatoreDecimale: string;
}
//#endregion configuration
//#region mappginField
export interface iMappingField {
	columnName: string;
	columnDataType: string;
	columnLength: number | null;
	systemRequired: boolean;
	sourceCode: string;
	mappingRequired: boolean;
	default: any;
}
export class mappingFieldBase implements iMappingField {
	columnName: string;
	columnDataType: string;
	columnLength: number | null;
	systemRequired: boolean;
	sourceCode: string;
	mappingRequired: boolean;
	default: any;
}
//#endregion mappginField
